import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import parser from 'fast-xml-parser'
var he = require('he');
import moment from 'moment';

Vue.use(Vuex)


export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
